import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { IUser } from '../../../../types/interfaces/user';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (changeRequest: IUser) => void,
  onDelete: (changeRequest: IUser) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.FIRSTNAME,
      cellReducer: (user: IUser) => {
        return <div className={classes.firstname}>{user.firstname}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.lastname,
      cellReducer: (user: IUser) => {
        return <div className={classes.lastname}>{user.lastname}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.EMAIL,
      cellReducer: (user: IUser) => {
        return <div className={classes.email}>{user.email}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.ROLE,
      cellReducer: (user: IUser) => {
        return <div className={classes.role}>{user.role.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      cellReducer: (user: IUser) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={user.active}></Checkbox>
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.UID,
      cellReducer: (user: IUser) => {
        return <div className={classes.uid}>{user.uid}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.HIDDEN,
      cellReducer: (user: IUser) => {
        return (
          <div className={classes.hidden}>
            <Checkbox disabled checked={user.hidden}></Checkbox>
          </div>
        );
      },
    },

    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (user: IUser) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(user);
                        }}></EditActionButton>
                    )}

                    {canDelete && user.active && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(user);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
